// project-imports
import { ThemeMode } from 'config';

import { clacPaletteRamps } from 'utils/uiTokens';

// types
import { PaletteThemeProps } from 'types/theme';

// ==============================|| PRESET THEME - CLAC ||============================== //
// Sistema de Diseño CLAC - Marca Oficial v2
// Verde Institucional #BDCD12 + Azul Acento #1E70B9

export default function Clac(mode: ThemeMode): PaletteThemeProps {
  const contrastText = '#fff';

  // Las rampas viven en `utils/uiTokens.ts`, junto al resto de los colores del sistema.
  const ramp = mode === ThemeMode.DARK ? clacPaletteRamps.dark : clacPaletteRamps.light;
  const primaryColors = ramp.primary;
  const secondaryColors = ramp.secondary;
  const errorColors = ramp.error;
  const warningColors = ramp.warning;
  const infoColors = ramp.info;
  const successColors = ramp.success;

  return {
    primary: {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      contrastText
    },
    secondary: {
      lighter: secondaryColors[0],
      100: secondaryColors[1],
      200: secondaryColors[2],
      light: secondaryColors[3],
      400: secondaryColors[4],
      500: secondaryColors[5],
      main: secondaryColors[6],
      dark: secondaryColors[7],
      800: secondaryColors[8],
      darker: secondaryColors[9],
      contrastText
    },
    error: {
      lighter: errorColors[0],
      light: errorColors[1],
      main: errorColors[2],
      dark: errorColors[3],
      darker: errorColors[4],
      contrastText
    },
    warning: {
      lighter: warningColors[0],
      light: warningColors[1],
      main: warningColors[2],
      dark: warningColors[3],
      darker: warningColors[4],
      contrastText
    },
    info: {
      lighter: infoColors[0],
      light: infoColors[1],
      main: infoColors[2],
      dark: infoColors[3],
      darker: infoColors[4],
      contrastText
    },
    success: {
      lighter: successColors[0],
      light: successColors[1],
      main: successColors[2],
      dark: successColors[3],
      darker: successColors[4],
      contrastText
    }
  };
}
